export class Accordion{
	init() {
		let self = this;
		if($('.features-list--risks').length){
			$('.features-list--risks').each(function() {
				var mainParent = this,
					organizationalChart = this.classList.contains('features-list--risks-chart');

				$(this).find('.features-list__header').each(function() {
					let $this = $(this);
					$this.unbind().on('click', function(e) {
						if(this.classList.contains('show-all')){
							$this.toggleClass('active');
							let chartRisks = $this.closest('.features-list--risks-chart');
							if(this.classList.contains('active')){
								this.querySelector('h5').innerText = 'Hide all';
								$(mainParent).find('.features-list__content').slideDown();
								$(mainParent).find('.features-list__header').addClass('active');
								$(mainParent).find('.features-list__item').addClass('visible');
							}else{
								this.querySelector('h5').innerText = 'Show all';
								$(mainParent).find('.features-list__content').slideUp();
								$(mainParent).find('.features-list__header').removeClass('active');
								$(mainParent).find('.features-list__item').removeClass('visible');
								if(chartRisks){
									$('html,body').animate({
										scrollTop: 0
									}, 500)
								}
							}
						}else{
							$this.toggleClass('active');
							$this.siblings('.features-list__content').slideToggle();
							if(organizationalChart){
								$this.closest('.features-list__item').toggleClass('visible');
								$this.siblings('.features-list__content').find('.features-list__header').trigger('click');
							}
							self.checkOpened(mainParent);
							$('html, body').animate({
								scrollTop: $(this).offset().top
							}, 500)
						}
					});
				});

				$(this).find('.features-list-sfdr__header').each(function() {
					let $this = $(this);
					$this.unbind().on('click', function(e) {
						if(this.classList.contains('show-all')){
							$this.toggleClass('active');
							let chartRisks = $this.closest('.features-list-sfdr--risks-chart');
							if(this.classList.contains('active')){
								this.querySelector('h6').innerText = 'Hide all';
								$(mainParent).find('.features-list-sfdr__content').slideDown();
								$(mainParent).find('.features-list-sfdr__header').addClass('active');
								$(mainParent).find('.features-list-sfdr__item').addClass('visible');
							}else{
								this.querySelector('h6').innerText = 'Show all';
								$(mainParent).find('.features-list-sfdr__content').slideUp();
								$(mainParent).find('.features-list-sfdr__header').removeClass('active');
								$(mainParent).find('.features-list-sfdr__item').removeClass('visible');
								if(chartRisks){
									$('html,body').animate({
										scrollTop: 0
									}, 500)
								}
							}
						}else{
							$this.toggleClass('active');
							$this.siblings('.features-list-sfdr__content').slideToggle();
							if(organizationalChart){
								$this.closest('.features-list-sfdr__item').toggleClass('visible');
								$this.siblings('.features-list-sfdr__content').find('.features-list-sfdr__header').trigger('click');
							}
							self.checkOpened(mainParent);
							$('html, body').animate({
								scrollTop: $(this).offset().top
							}, 500)
						}
					});
				});
			})
		}
	}
	checkOpened(parent) {
		let countRisks = parent.querySelectorAll('.features-list__header:not(.show-all)').length,
			countActiveRisks = parent.querySelectorAll('.features-list__header.active:not(.show-all)').length,
			mainTrigger = parent.querySelector('.features-list__header.show-all h5');

		if(countRisks == countActiveRisks){
			if(mainTrigger){
				mainTrigger.innerText = "Hide all";
				mainTrigger.parentElement.classList.add('active');
			} 
		}else{
			if(mainTrigger){
				mainTrigger.innerText = "Show all";
				mainTrigger.parentElement.classList.remove('active');
			}
		}
	}
	checkOpenedSfdr(parent) {
		let countRisks = parent.querySelectorAll('.features-list-sfdr__header:not(.show-all)').length,
			countActiveRisks = parent.querySelectorAll('.features-list-sfdr__header.active:not(.show-all)').length,
			mainTrigger = parent.querySelector('.features-list-sfdr__header.show-all h6');

		if(countRisks == countActiveRisks){
			if(mainTrigger){
				mainTrigger.innerText = "Hide all";
				mainTrigger.parentElement.classList.add('active');
			} 
		}else{
			if(mainTrigger){
				mainTrigger.innerText = "Show all";
				mainTrigger.parentElement.classList.remove('active');
			}
		}
	}
}